<template>
  <div class="columns">
    <b-field
      :label="$t('addNewRelance.dateRelanceEdit')"
      :message="alerteMsgDate"
      :type="alerteMsgDate ? 'is-warning' : ''"
      class="column is-2 obligatoire">
      <b-datepicker
        show-week-number
        v-model="dateRelance"
        icon="calendar-today"
        nearby-selectable-month-days
        editable>
      </b-datepicker>
    </b-field>
    <b-field :label="$t('addNewRelance.niveauRelance')" class="column obligatoire">
      <b-select
        v-model="niveauRelance"
        @input="majTexteRelance">
        <option
          v-for="(niveau, index) in constantes.NIVEAU_RELANCES"
          :key="index"
          :value="niveau.code">
          {{ $t(niveau.libelle) }}
        </option>
      </b-select>
    </b-field>
    <div class="column is-narrow is-fullheight">
      <b-tooltip :label="$t('addNewRelance.actions.reinitialiserTooltip')">
        <button
          class="button is-addOrEdit mgt-28px"
          @click="majTexteRelance">
          {{ $t('addNewRelance.actions.reinitialiser')}}
        </button>
      </b-tooltip>
    </div>
  </div>
</template>

<script>

import formatIsoDate from '@/services/general/formatIsoDate';
import { NIVEAU_RELANCES } from '@/configuration/relances/relancesConf';

export default {
  props: {
    numberRelance: Number,
    date: Date,
  },
  data() {
    return {
      dateRelanceSave: null,
      constantes: {
        NIVEAU_RELANCES,
      },
    };
  },
  computed: {
    dateRelance: {
      get() {
        return this.date;
      },
      set(newDate) {
        this.$emit('update:date', newDate);
      },
    },
    niveauRelance: {
      get() {
        return this.numberRelance;
      },
      set(newNumRelance) {
        this.$emit('update:numberRelance', newNumRelance);
      },
    },
    alerteMsgDate() {
      return this.dateRelanceSave
        && this.dateRelanceSave !== formatIsoDate(this.dateRelance)
        ? this.$t('addNewRelance.msgWarningDateRelance') : '';
    },
  },
  methods: {
    majTexteRelance() {
      this.dateRelanceSave = formatIsoDate(this.dateRelance);
      this.$emit('reinitialiserTexte');
    },
  },
  mounted() {
    this.dateRelanceSave = formatIsoDate(this.dateRelance);
  },
};
</script>
